"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupOfferPositionDTO = void 0;
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
// eslint-disable-next-line import/no-cycle
const AbstractOfferPositionDTO_1 = require("./AbstractOfferPositionDTO");
// eslint-disable-next-line import/no-cycle
const ScalarOfferPositionDTO_1 = require("./ScalarOfferPositionDTO");
class GroupOfferPositionDTO extends AbstractOfferPositionDTO_1.AbstractOfferPositionDTO {
    static isGroupPos(position) {
        return position.positionType === 'group';
    }
}
exports.GroupOfferPositionDTO = GroupOfferPositionDTO;
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => ScalarOfferPositionDTO_1.ScalarOfferPositionDTO),
    __metadata("design:type", Array)
], GroupOfferPositionDTO.prototype, "positions", void 0);
